import {LivePenaltiesModuleFetchHandler} from "./live-penalties-module.fetch-handler";
import {TimingHandler} from "../../../infrastructure/handlers/timing-handler";
import {PopulateDataHandler} from "../../../infrastructure/handlers/populate-data-handler";
import {HandlerList} from "../../../infrastructure/handlers/handler-list";
import {LivePenaltiesModulePlayerChangeHandler} from "./live-penalties-module.player-change.handler";
import {LivePenaltiesModuleDisplayEventHandler} from "./live-penalties-module.display.event-handler";
import {LivePenaltiesModulePlayerSwipeEventHandler} from "./live-penalties-module.player-swipe.event-handler";
import {LivePenaltiesModuleCloseEventHandler} from "./live-penalties-module.close.event-handler";

export class LivePenaltiesModuleHandlers extends HandlerList {
  static injectables = [
    LivePenaltiesModuleFetchHandler,
    LivePenaltiesModulePlayerChangeHandler,
    LivePenaltiesModuleDisplayEventHandler,
    LivePenaltiesModulePlayerSwipeEventHandler,
    LivePenaltiesModuleCloseEventHandler,
    TimingHandler,
    PopulateDataHandler
  ];

  constructor(
    livePenaltiesModuleFetchHandler: LivePenaltiesModuleFetchHandler,
    livePenaltiesModulePlayerChangeHandler: LivePenaltiesModulePlayerChangeHandler,
    livePenaltiesModuleDisplayEventHandler: LivePenaltiesModuleDisplayEventHandler,
    livePenaltiesModulePlayerSwipeEventHandler: LivePenaltiesModulePlayerSwipeEventHandler,
    livePenaltiesModuleCloseEventHandler: LivePenaltiesModuleCloseEventHandler,
    timingHandler: TimingHandler,
    populateDataHandler: PopulateDataHandler
  ) {
    super();

    [
      livePenaltiesModuleFetchHandler,
      livePenaltiesModulePlayerChangeHandler,
      livePenaltiesModuleDisplayEventHandler,
      livePenaltiesModulePlayerSwipeEventHandler,
      livePenaltiesModuleCloseEventHandler,
      timingHandler,
      populateDataHandler
    ].forEach(handler => this.add(handler));
  }
}
